import type { CustomPricingBase, CustomPricingContext } from "@classes-service-types/index.ts";
import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { learningServiceRequest } from "@/services/utils";
import { QUERY_KEY } from "./useGetCustomPricingList";
import { getQueryKey } from "./useGetCustomPricingOne";

type UpdateCustomPricingArgs = {
  overrideId: string;
  data: Partial<CustomPricingBase>;
};

export const useUpdateCustomPricing = (
  useMutationOptions?: UseMutationOptions<CustomPricingContext, Error, UpdateCustomPricingArgs>,
) => {
  const queryClient = useQueryClient();

  return useMutation<CustomPricingContext, Error, UpdateCustomPricingArgs>({
    mutationFn: async ({ overrideId, data }) => {
      const response: AxiosResponse<{ data: CustomPricingContext }> = await learningServiceRequest({
        method: "put",
        url: `/custom_pricing/${overrideId}/`,
        payload: { data },
      });
      return response.data.data;
    },
    onSuccess: (_result, { overrideId }) => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: getQueryKey(overrideId) });
    },
    ...useMutationOptions,
  });
};
